module.exports = __webpack_public_path__ + "static/media/kake_green-min.fe563422.png";